import type { Plugin } from 'vue';
import type { AuthCreateOptions, AuthProvider } from './auth';
import { inject } from 'vue';
import { createAuth } from './auth';

export const authPlugin: Plugin<[AuthCreateOptions]> = {
  install(app, options) {
    const auth = createAuth(options);
    app.provide('auth', auth);
  },
};

export function useAuth(): AuthProvider {
  return inject('auth')!;
}
